/**
 * [ui1006, paczka PROC] KLUCZE STRONY „Procedury i bezpieczeństwo” — jedno miejsce, czytane przez rejestr obszarów
 * (`config/obszary/procedury.js`) i źródła startu (`pages/polityki/zrodlaStartu.js`). Osobny plik, bo rejestr importuje
 * źródła startu, a źródła potrzebują kluczy — wspólny import zamiast pętli importów.
 */

/** Pięć kluczy modułu — którykolwiek otwiera stronę (ranga administratora nic tu nie otwiera). */
export const KLUCZE_PROCEDUR = Object.freeze(["PolitykiRedakcja", "PolitykiUstawienia", "PolitykiRaportPotwierdzen", "PolitykiRejestrujDecyzje", "PolitykiRejestrujPotwierdzenia"]);

/** Ustawienia modułu czyta redakcja ALBO posiadacz klucza ustawień (tak wpuszcza `GET /polityki/ustawienia`). */
export const KLUCZE_USTAWIEN_PROCEDUR = Object.freeze(["PolitykiRedakcja", "PolitykiUstawienia"]);

/** „Stanowiska” żyją z `GET /polityki/stanowiska/raport` (nazwiska i stanowiska) — klucz raportu potwierdzeń. */
export const KLUCZ_RAPORTU_STANOWISK = "PolitykiRaportPotwierdzen";

/** „Różne nazwy stanowisk” żyją z `GET /polityki/stanowiska/warianty` — klucz redakcji. */
export const KLUCZ_NAZW_STANOWISK = "PolitykiRedakcja";
